import { useMemo } from "react";

import { useGetPlanReviewCategoriesQuery } from "graphql/queries/get-plan-review-categories.generated";

/**
 * The Review Categories one AHJ files its rules under.
 *
 * Every screen that offers a category reads it from here, so a category the office
 * adds shows up without a deploy — and one it deactivates stops being offered while
 * the rules already filed under it keep reading correctly.
 */
export const usePlanReviewCategories = (jurisdictionId: string) => {
	const { data, loading, error } = useGetPlanReviewCategoriesQuery({
		skip: !jurisdictionId,
		variables: { jurisdictionId },
		fetchPolicy: "cache-and-network"
	});

	const categories = useMemo(() => data?.plan_review_categories ?? [], [data]);

	const categoryOptions = useMemo(
		() => categories.map(category => ({ label: category.name, value: category.id })),
		[categories]
	);

	return { categories, categoryOptions, loading, error };
};
